import { UserService } from 'app/services/user.service';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormArray, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { format, validate, clean } from '@dgitals/rut';
import { User } from '../../../models/user.model';
import { catchError, take, switchMap, map, takeUntil } from 'rxjs/operators';
import { of, Subscription, Subject } from 'rxjs';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
@Component({
    selector: "app-change-password",
    templateUrl: "./change-password.component.html",
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class changePasswordComponent implements OnInit {
    
    alert: { type: FuseAlertType; message: string } = {
        type   : 'success',
        message: ''
    };
    showAlert: boolean = false;
    loading = false;
    private _unsubscribeAll: Subject<any>;

    cambiarSII = 0;
    success = false
    user = null;
    nombreUsuario = null;
    rutUsuario = null;
    correoUsuario = null
    telefonoUsuario = null
    registerCedente: FormGroup;
    hide = true;

    hidePass = true;
    hidePassRepeat = true;



    pass: FormGroup;

    constructor(
        public dialogRef: MatDialog,
        private _formBuilder: FormBuilder,
        private _user: UserService,
    ) {
        this._unsubscribeAll = new Subject();

        this._user.user$
            .pipe((takeUntil(this._unsubscribeAll)))
            .subscribe((user: User) => {
                this.user = user;
            });

        this.pass = this._formBuilder.group({
            CLAVE_NUEVA: ['',
                [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&"*%¿¡?=(/\'\\\[)]).{8,}')]
            ],
            CLAVE_REPEAT: ['', [Validators.required, this.matchValues('CLAVE_NUEVA')]],
        });

        this.pass.controls.CLAVE_NUEVA.valueChanges.subscribe(() => {
            this.pass.controls.CLAVE_REPEAT.updateValueAndValidity();
        });

    }

    ngOnInit(): void {

    }

    isShowMenuHeader: boolean = false;

    handleChangeShowMenuHeader() {
        this.isShowMenuHeader = !this.isShowMenuHeader;
    }

    closeShowMenuHeader() {
        if (this.isShowMenuHeader) {
            this.isShowMenuHeader = false;
        }
    }

    get disabledButton(): boolean {
        const { CLAVE_NUEVA, CLAVE_REPEAT } = this.pass.value
        return CLAVE_NUEVA.trim() === '' && CLAVE_REPEAT.trim() === ''
    }

    // handleChange(event): void {
    //     const { name, value } = event.target
    //     this.values = { ...this.values, [name]: value }
    // }

    matchValues(
        matchTo: string // name of the control to match to
    ): (AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            return !!control.parent &&
                !!control.parent.value &&
                control.value === control.parent.controls[matchTo].value
                ? null
                : { isMatching: false };
        };
    }

    changePassword() {
        if (this.pass.get('CLAVE_NUEVA').value == this.pass.get('CLAVE_REPEAT').value) {
            this._user.changePassword(this.pass.get('CLAVE_NUEVA').value).pipe(takeUntil(this._unsubscribeAll)).subscribe({
                next: (data) => {
                    if (data.success) {
                        this.success = true;
                        this.alert = {
                            type   : 'success',
                            message: 'Contraseña actualizada correctamente.'
                        };
                        this.showAlert = true;
                        this._user.logOut();
                    } else {
                        this.alert = {
                            type   : 'error',
                            message: 'No se pudo completar la operación de cambio de contraseña.'
                        };
                        this.showAlert = true;
                    }
                },
                error: (e: any) => {
                    let {
                        error,//"PasswordStrengthError" | "PasswordHistoryError" | "OtherError";
                        message//string;
                    } = e.error;

                    switch (error) {
                        case "PasswordStrengthError":
                            this.alert = {
                                type   : 'error',
                                message: 'Contraseña no cumple con formato de seguridad.'
                            };
                            break;
                        case "PasswordHistoryError":
                            this.alert = {
                                type   : 'error',
                                message: 'No puedes utilizar una contraseña anterior.'
                            };
                            break;
                        default:
                            this.alert = {
                                type   : 'error',
                                message: 'No se pudo completar la operación'
                            };
                            break;
                    }
                    this.showAlert = true;

                },
                complete: () => {
                }
            });

        }
        else {
            this.alert = {
                type   : 'error',
                message: 'las contraseñas deben coincidir.'
            };
        }
    }

    logout() {
        this._user.logOut();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        // this.consulta_Cedente.unsubscribe();
        // this.register_Cedente.unsubscribe();
    }
}